import { useTranslation } from "react-i18next"

export default function Footer({ navItems, darkMode, setDarkMode }) {
  const { t, i18n } = useTranslation()

  return (
    <footer className="py-8 bg-gray-800 dark:bg-gray-950 text-gray-300 px-4">
      <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-3 items-center text-sm">
        <p className="text-center md:text-left">
          © {new Date().getFullYear()} Autodoprava Chochola
        </p>
        <div className="flex justify-center space-x-6 order-last md:order-none">
          {navItems.map((item) => (
            <a
              key={item.slug}
              href={`#${item.slug}`}
              className="hover:text-white transition text-sm"
            >
              {item.label.charAt(0).toUpperCase() + item.label.slice(1)}
            </a>
          ))}
        </div>
        <div className="flex justify-center md:justify-end items-center space-x-4">
          <button
            onClick={() => setDarkMode(!darkMode)}
            className="px-3 py-2 border rounded hover:bg-gray-700 hover:text-white transition"
          >
            {darkMode ? t("footer.light") : t("footer.dark")}
          </button>
          <select
            className="bg-transparent border rounded px-2 py-2 appearance-none cursor-pointer shadow-none"
            value={i18n.language}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
          >
            <option value="cs">CZ</option>
            <option value="en">EN</option>
          </select>
        </div>
      </div>
    </footer>
  )
}
